import React, { useState, useEffect } from "react";
import TreeItem from "../TreeItem/TreeItem";
import "./Tree.css";
import CollapseCommand from "../Commands/CollapseCommand/CollapseCommand";
import ReduceCommand from "../Commands/ReduceCommand/ReduceCommand";
//import { useEffect } from "react/cjs/react.development";

export default function Tree (props) {
 
    var check = [];
    var exp = [];
    var menuPaths = [];
    var menuPathsLabel = [];
       
    const [tree, setTree] = useState({
      pageSize:props.pageSize ? props.pageSize:10,
      currentMax:props.pageSize ? props.pageSize:10,
      scrolls:[],
      checkeds: check,
      checkedsPath:[],
      expandeds: exp,
      menuPaths: menuPaths,
      menuPathsLabel: menuPathsLabel,
    });
  
    useEffect (() => {
      var check = [];
      var exp = [];
      var menuPaths = [];
      var menuPathsLabel = [];
      //getFilteredArray(props.menuItems,  exp,check, menuPaths, undefined, false, menuPathsLabel  );
      getFilteredArray(getMenuToShow(props.menuItems),  exp,check, menuPaths, undefined, false, menuPathsLabel  );
      
      setTree({...tree,
        menuPaths: menuPaths,
        menuPathsLabel: menuPathsLabel,
      })
    }, [JSON.stringify(props.menuItems)]);
 

    const getFilteredArray = (arrayMenu, exp, check, menuPaths, parentId, canAdd, menuPathsLabel, ancestorId = 0) => {
      if (arrayMenu == undefined) { //if (arrayMenu == "") {
  
        if (canAdd) check.push(parentId);
        return;
      }
      arrayMenu.map((item) => {
        if (item.isExpanded) {
          exp.push(item.id);
        }
        canAdd = item.isChecked;
  
        if (parentId == undefined) { //if (parentId == "") {
          
          menuPaths.push([item.id]);
          menuPathsLabel.push({id:item.id, item:item.item, childs: []})
          ancestorId = item.id
          
        }
        else {
          if (canAdd) check.push(parentId);
          var n = menuPaths.length - 1;
          var i = menuPaths[n].length - 1;
          var val = menuPaths[n][i];
          if (parentId == val) {
            menuPaths[n].push(item.id);
            
          }
          else {
            var index = menuPaths[n].indexOf(parentId);
            menuPaths.push(menuPaths[n].slice(0, index + 1));
            menuPaths[n + 1].push(item.id);
          }
          var current = menuPathsLabel.filter(item => item.id == ancestorId)[0]
          if (!current.childs.map(item => item.id).includes(item.id))
            current.childs.push({id:item.id, item:item.item});
        }
            
        return getFilteredArray(item.childs, exp, check, menuPaths, item.id,  canAdd,  menuPathsLabel, ancestorId );
      });
    };
  const onExpandCollapseClick =  (e, isExpanded, idMenu) => {
    if (isExpanded) {
      deleteMenuIdFromExpandeds(idMenu);
    } else {
      addMenuIdToExpandeds(idMenu);
    }
  }

  const onCheckBoxClick = (e, isChecked, menu) =>  {
    if (isChecked) deleteMenuIdFromCheckeds(menu);
    else addMenuIdToCheckeds(menu);
  }

  

  const getNestedNode = (menu, arrayNode) => {
    if (menu.childs.length == 0) arrayNode.push(menu.id);
    menu.childs.map((item) => {
      arrayNode.push(menu.id);
      return getNestedNode(item, arrayNode);
    });
  };

  const getParentNode = (idMenu, isToAdd, treeCheckeds = tree.checkeds) => {
    var parentNodes = [];
    var menuPath = tree.menuPaths;
   
    for (let i = 0; i < menuPath.length; i++) {
      if (menuPath[i][0] === idMenu) {
        return [];
      } else {
        parentNodes = [];
        var n = menuPath[i].length;
        var parentNodeId = 0;
        for (let j = 0; j < n; j++) {
          var curentNodeId = menuPath[i][j];
          if (curentNodeId === idMenu) {
            if (isToAdd) parentNodes.push(parentNodeId);
            return parentNodes;
          } else {
            if (isToAdd) {
              var isChildChecked = treeCheckeds.includes(curentNodeId);
              if (j != 0 && !isChildChecked) parentNodes.push(parentNodeId);
            } else {
              var iscurentNodeOnlyOneChecked =
                treeCheckeds.filter((item) => item == curentNodeId)
                  .length == 1;
              if (!iscurentNodeOnlyOneChecked) parentNodes = [];
              parentNodes.push(curentNodeId);
            }
          }
          parentNodeId = curentNodeId;
        }
      }
    }

    return [];
  };

  const addMenuIdToCheckeds = (menu) => {
    var nestedNodeId = [];
    getNestedNode(menu, nestedNodeId);
    var parentNodeId = getParentNode(menu.id, true, props.singleChecked ? [] : tree.checkeds);
    var newChecked = [];
    var newCheckedsPath = []
    if (!props.leafSelection || (props.leafSelection && nestedNodeId.length == 1)  ) {
      if (props.singleChecked) {
        //console.log(parentNodeId)
        //let globalId = parentNodeId.length && props.menuItems.filter(ancestor => ancestor.id == parentNodeId[0])[0].globalId
        //if (globalId)
          //newChecked = [globalId, ...parentNodeId, nestedNodeId[0]]; //,...nestedNodeId
        //else
        newChecked = [...parentNodeId, nestedNodeId[0]]; //,...nestedNodeId
        
        setTree({...tree, 
          checkeds: newChecked, //[...parentNodeId,...nestedNodeId],
        });
      }
      else {
        newChecked = [...tree.checkeds, ...parentNodeId, ...nestedNodeId];
        newCheckedsPath= [...tree.checkedsPath, [ ...parentNodeId, ...nestedNodeId]]
        
        setTree({...tree,
          checkeds: newChecked,//[...previoustree.checkeds, ...nestedNodeId, ...parentNodeId],
          checkedsPath: newCheckedsPath
        });
      }
      
      props.onCheckedItem(newChecked, tree.menuPathsLabel, tree.menuPaths, newCheckedsPath)
    }
  }

  const deleteMenuIdFromCheckeds=  (menu) => {
    var nestedNodeId = [];
    getNestedNode(menu, nestedNodeId);
    var parentNodeId = getParentNode(menu.id, false);
    var newCheckeds = tree.checkeds.filter(
      (item) => !nestedNodeId.includes(item)
    );
    var newCheckedsPath = tree.checkedsPath.filter(
      (item) => !item.includes(menu.id)
    );
    
    parentNodeId.map((item) => {
      if (newCheckeds.includes(item))
        newCheckeds = removeFirstOccurence(newCheckeds, item);
    });
    setTree({...tree,
      checkeds: newCheckeds,
      checkedsPath: newCheckedsPath
    });
    props.onUnCheckedItem(newCheckeds, tree.menuPathsLabel, tree.menuPaths)
  }

  const addMenuIdToExpandeds = (id) =>  {
    setTree({...tree,
      expandeds: [...tree.expandeds, id],
    });
  }
  
  const deleteMenuIdFromExpandeds = (idMenu) =>  {
    var newExpandeds = tree.expandeds.filter((item) => item !== idMenu);
    setTree({...tree,
      expandeds: newExpandeds,
    });
  }

  const isAllChildsChecked = (menu) => {
    var arrayNodes = [];
    getNestedNode(menu, arrayNodes);
    arrayNodes = arrayNodes.filter((item) => item != menu.id);
    return !arrayNodes.some((item) => !tree.checkeds.includes(item));
  }

  const isCheckedNode = (idMenu) => {
    return tree.checkeds.includes(idMenu);
  };

  const isExpandedNode = (idMenu) => {
    return tree.expandeds.includes(idMenu);
  };

  const removeFirstOccurence = (src, value) => {
    var index = src.indexOf(value);
    if (index == -1) return src;
    else return [...src.slice(0, index), ...src.slice(index + 1)];
  };

  const canAddThisLine= (index, id) => {
    let actualCurrentMax = getCurrentMax(id)
    return index >= (actualCurrentMax - tree.pageSize) && index < actualCurrentMax;
  };

  const getCurrentMax = (nodeId) => {
    let currentScroll = tree.scrolls.filter(item => item.id == nodeId)[0]
    return currentScroll ? currentScroll.currentMax : tree.currentMax;
  };

  const onScrollBottom = (nodeId) => {
    let currentScrolls = [...tree.scrolls]
    if (!currentScrolls.filter(item => item.id == nodeId)[0])
      setTree({...tree,
        scrolls: [...currentScrolls, {id:nodeId, currentMax:tree.currentMax + tree.pageSize   } ], //[...parentNodeId,...nestedNodeId],
      })
    else {
      currentScrolls.filter(item => item.id ==nodeId)
        .map(item => item.currentMax = item.currentMax + tree.pageSize)
      setTree({...tree,
        scrolls: currentScrolls, //[...parentNodeId,...nestedNodeId],
      })
    }
  };

  const onScrollTop = (nodeId) => {
    let currentScrolls = [...tree.scrolls]
    let newCurrentScrolls = getCurrentMax(nodeId) - tree.pageSize
    if (newCurrentScrolls != tree.currentMax && newCurrentScrolls > 0) {
      currentScrolls.filter(item => item.id ==nodeId)
        .map(item => item.currentMax = item.currentMax - tree.pageSize)

      setTree({...tree,
        scrolls: currentScrolls, //[...parentNodeId,...nestedNodeId],
      })
    }
    else {
      
      setTree({...tree,
        scrolls: currentScrolls.filter(item => item.id != nodeId), //[...parentNodeId,...nestedNodeId],
      })
    }
  };
  
  const getMenuToShow = (menuItems, menuId) => {
    let actualCurrentMax = menuId ? getCurrentMax(menuId) : tree.currentMax
    let minCurrentMax = actualCurrentMax - tree.pageSize
    return menuItems.length < tree.pageSize ? menuItems : menuItems.slice(minCurrentMax, actualCurrentMax)
  };

  const showMenu = (menu) => {
    if (menu == "") return;
    var isMenuHasChilds = menu.childs.length > 0;
    var isExpanded = isMenuHasChilds && isExpandedNode(menu.id);
    var isChecked = isCheckedNode(menu.id);
    var isLeastOneAndNotAllChildsChecked =
      isMenuHasChilds && isChecked && !isAllChildsChecked(menu);
  
    return (
      <li key={menu.id} name={menu.id} className={isExpanded ? "liOpen" : "li"}>
        <TreeItem
          item={menu.item  +  (menu.type || menu.type == "" ? " : " + menu.type : "")}
          withCheckBox={props.withCheckBox}
          isMenuHasChilds={isMenuHasChilds}
          backgroundColor={props.backgroundColor}
          isLeastOneAndNotAllChildsChecked={isLeastOneAndNotAllChildsChecked}
          onExpandCollapseClick={(e) =>
            onExpandCollapseClick(e, isExpanded, menu.id)
          }
          isExpanded={isExpanded}
          onCheckBoxClick={(e) => onCheckBoxClick(e, isChecked, menu)}
          onScrollBottom={() => onScrollBottom(menu.id)}
          onScrollTop={() => onScrollTop(menu.id)}
          isChecked={isChecked}
          //showScrollTop={menu.childs.length > tree.pageSize && tree.currentMax > tree.pageSize}
          //showScrollBottom={menu.childs.length > tree.currentMax }
          showScrollTop={tree.scrolls.map(item => item.id).includes(menu.id)}
          showScrollBottom={ menu.childs.length > getCurrentMax(menu.id) }
        />
        {isMenuHasChilds > 0 && (
          <ul className="ul" key={menu.id}>
            {getMenuToShow(menu.childs, menu.id).map((item, index) => showMenu(item))} 
          </ul>
        )}
      </li>
    );
  };

    const parentAncestorId = -1
    const ancestorItems = getMenuToShow(props.menuItems, parentAncestorId)
    
   
    return (
    <React.Fragment>
      {props.showToolbar && <div style={{ display: "flex"}}>
        <span  style={{ marginLeft: "10px"}} >Size: </span>
        <input className = "textBox" style={{ marginLeft: "10px", width: "30px" }} 
          value = {tree.pageSize} 
          onChange = {(e) => e.target.value != "" && !isNaN(e.target.value) && setTree({...tree, pageSize:parseInt(e.target.value), currentMax:parseInt(e.target.value)})} />
        
        <div style={{ display: "flex", marginLeft: "auto" }}>
          <div onClick={() => onScrollTop(parentAncestorId)} style={{ width: "20px" }}  >
            <ReduceCommand isShow={tree.scrolls.map(item => item.id).includes(parentAncestorId)} isStandard={true} />
          </div>
          <div onClick={() => onScrollBottom(parentAncestorId)} style={{ width: "20px" }}>
            <CollapseCommand isShow={props.menuItems.length > getCurrentMax(parentAncestorId)} isStandard={true} />
          </div>
        </div>
      </div>}
       {ancestorItems.map((item, index) => (
        <ul className="ulbase" key={"ul" + item.id}>
          {showMenu(item)}
        </ul>
      ))}
    </React.Fragment>)
  
}


